export function randomNumber(): number {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0] / (2**32); // Normalize to a value between 0 and 1
}
